import { render, staticRenderFns } from "./Grid5LoanAgingTable.vue?vue&type=template&id=19384c7c"
import script from "./Grid5LoanAgingTable.vue?vue&type=script&lang=js"
export * from "./Grid5LoanAgingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports